<template>
  <div>
    <base-modal hide-footer hide-header @close="$emit('close')" size="lg">
      <div class="editor-form form-data">
          <h2 class="editor-header">{{ $t('search_works.title') }}</h2>
          <div class="col-12">
            <span
              v-for="contract in contracts"
              :key="contract.id"
              class="span-title"
            >{{ contract.name }}</span>
          </div>
          <div class="col-12">
              <span class="span-title">{{ $t('search_works.time_range') }}</span>
          </div>
        <div class="row">
          <div class="col-sm-6">
            <span class="span-title">{{ $t('ins_report.from_date') }}</span>
            <date-time-picker
              v-model:date="fromDate"
              class="routa-input"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>
          <div class="col-sm-6">
            <span class="span-title">{{ $t('ins_report.to_date') }}</span>
            <date-time-picker
              v-model:date="toDate"
              class="routa-input"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>
        </div>
        <div v-if="roadData.name" class="col-12">
          <span class="span-title title">{{ roadData.name }}</span>
        </div>
          <vue3-datatable
              v-if="works.length > 0"
              ref="resultTable"
              :rows="works"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="false"
              skin="bh-table-compact"
              cell-class="routa-table-cell"
          >
              <template #time="row">
                  {{ toLocalTime(row.value.time.start) }}
              </template>
              <template #contract="row">
                  {{ row.value.contract.name }}
              </template>
          </vue3-datatable>

        <div class="col-12 text-end mt-2">
          <button class="btn btn-secondary form-button" @click="$emit('close')">
            {{ $t('common.close') }}
          </button>
          <button class="btn btn-primary form-button" :disabled="isSearchDisabled" @click.stop="searchWorks">
            {{ $t('common.search') }}
          </button>
        </div>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '../BaseModal'
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from '../mixins/TimeUtils'
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'WorkSearchWizard',
    components: { BaseModal, DateTimePicker, Vue3Datatable },
    mixins: [restApi, timeUtils],
    props: {
        coordinates: {
            type: Object,
            default() {
                return null
            },
        },
        contracts: {
            type: Array,
            default() {
                return []
            },
        },
        map: {
            type: Object,
            default: null,
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false,
            roadData: {
                name: null,
            },
            fromDate: '',
            toDate: '',
            /** @type {Array<{ work: String, endTime: Date, startTime: Date }>} */
            works: [],
            fields: [
                { field: 'time', title: this.$t('trip.time'), headerClass: 'routa-table-header' },
                { field: 'work', title: this.$t('orders.contract'), headerClass: 'routa-table-header' },
                { field: 'contract', title: this.$t('orders.contract'), headerClass: 'routa-table-header' }
            ]
        }
    },
    computed: {
        isSearchDisabled() {
            const from = new Date(this.fromDate);
            const to = new Date(this.toDate);

            return !this.coordinates || !this.contracts || this.contracts.length === 0 || this.loading || to < from
        }
    },
    mounted() {
        this.fromDate = this.getMonthStart()
        this.toDate = this.getDayStart()
        if(this.coordinates) {
            this.fetchRoadDataByCoordinates(this.coordinates)
        }
    },
    methods: {
        fetchRoadDataByCoordinates(coord) {
            this.restFetchParams(this.roadAddressUrl, {lat: coord.lat, lon: coord.lng}, (response) => {
                if(response.data) {
                    this.roadData = {
                        name: response.data.name
                    }
                }
            }, () => {})
        },
        async searchWorks() {
            try {
                this.loading = true
                this.works = []
                if(this.coordinates && this.contracts.length > 0) {
                    const worksData = []
                    await Promise.all(this.contracts.map(async contract => {
                        return new Promise((resolver) => {
                            const params = {
                                lat: this.coordinates.lat,
                                lon: this.coordinates.lng,
                                age: this.getHoursDifference(this.fromDate, this.toDate),
                                contract: contract.id
                            }
                            this.restFetchParams(this.routaWfsUrl, params, (response) => {
                                if(response.data && response.data.totalFeatures > 0) {
                                    response.data.features.forEach(feature => {
                                        worksData.push({
                                            time: {
                                                start: feature.properties.alkamisaika,
                                                end: feature.properties.paattymisaika
                                            },
                                            work: feature.properties.toimenpidenimi,
                                            contract: contract,
                                        })
                                    });
                                }
                                resolver()
                            })
                        })
                    }))

                    this.loading = false
                    worksData.sort((a, b) => new Date(a.time.start) - new Date(b.time.start))
                    this.works = worksData
                }
            } catch (_error) {
                this.loading = false
                this.showAlert(this.$t('common.error'))
            }
        }
    }
}
</script>
<style scoped>
.title {
    color: black;
    font-weight: bold;
}
.works-table thead {
    display: none;
}
</style>
